module.exports = __webpack_public_path__ + "img/top.058d17bf.png";